import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import ConfirmDialog from '../ConfirmDialog';
import type { DipendenteStudio, SedeStudio } from '../../services/dipendentiService';
import { sedeDaValore, valoreSede } from '../../utils/sediDipendenti';

interface Props {
  dipendente: DipendenteStudio | null;
  sedi: SedeStudio[];
  onClose: () => void;
  onConferma: (dipendente: DipendenteStudio, sede: string | null) => void;
}

/**
 * «Cambia sede» di un dipendente (titolare e admin): scelta della sede e conferma. La sede è solo
 * organizzativa: non cambia gli accessi del dipendente.
 */
const DialogoCambiaSede: React.FC<Props> = ({ dipendente, sedi, onClose, onConferma }) => {
  const attuale = valoreSede(dipendente?.sede?.id);
  const [scelta, setScelta] = useState(attuale);

  useEffect(() => { setScelta(attuale); }, [dipendente, attuale]);

  const nominativo = dipendente ? `${dipendente.nome} ${dipendente.cognome}`.trim() : '';

  return (
    <ConfirmDialog
      isOpen={!!dipendente}
      onClose={onClose}
      onConfirm={() => { if (dipendente) onConferma(dipendente, sedeDaValore(scelta)); }}
      type="info"
      icon={<MapPin className="w-4 h-4" aria-hidden="true" />}
      title={dipendente ? `Cambiare la sede di ${nominativo}?` : ''}
      message="La sede serve solo a organizzare l'elenco: le sezioni e gli accessi del dipendente non cambiano."
      confirmText="Sposta"
      confirmDisabled={scelta === attuale}
    >
      <div className="mt-3">
        <label htmlFor="dipendente-nuova-sede" className="block text-xs font-medium text-gray-600 dark:text-gray-300 mb-1">
          Nuova sede
        </label>
        <select
          id="dipendente-nuova-sede"
          value={scelta}
          onChange={(e) => setScelta(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-indigo-500 outline-none"
        >
          {sedi.map((s) => (
            <option key={valoreSede(s.id)} value={valoreSede(s.id)}>{s.nome}</option>
          ))}
        </select>
      </div>
    </ConfirmDialog>
  );
};

export default DialogoCambiaSede;
